/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LabelFilter,
    LabelFilterFromJSON,
    LabelFilterFromJSONTyped,
    LabelFilterToJSON,
    RequiredCheckRule,
    RequiredCheckRuleFromJSON,
    RequiredCheckRuleFromJSONTyped,
    RequiredCheckRuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface RequiredChecksConfig
 */
export interface RequiredChecksConfig {
    /**
     * 
     * @type {boolean}
     * @memberof RequiredChecksConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {LabelFilter}
     * @memberof RequiredChecksConfig
     */
    exemptLabels?: LabelFilter;
    /**
     * 
     * @type {Array<RequiredCheckRule>}
     * @memberof RequiredChecksConfig
     */
    rules?: Array<RequiredCheckRule>;
}

export function RequiredChecksConfigFromJSON(json: any): RequiredChecksConfig {
    return RequiredChecksConfigFromJSONTyped(json, false);
}

export function RequiredChecksConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequiredChecksConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'exemptLabels': !exists(json, 'exemptLabels') ? undefined : LabelFilterFromJSON(json['exemptLabels']),
        'rules': !exists(json, 'rules') ? undefined : ((json['rules'] as Array<any>).map(RequiredCheckRuleFromJSON)),
    };
}

export function RequiredChecksConfigToJSON(value?: RequiredChecksConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'exemptLabels': LabelFilterToJSON(value.exemptLabels),
        'rules': value.rules === undefined ? undefined : ((value.rules as Array<any>).map(RequiredCheckRuleToJSON)),
    };
}

